module.exports = __webpack_public_path__ + "img/3.fb23ca98.png";